<p-confirmDialog key="merge" [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>

<!--Options-->
<div class="Grid2Col">
	<label>Add to:</label>
	<div class="RadioGrid">
		<input
			type="radio"
			id="Existing"
			value="Existing"
			name="GroupOption"
			[disabled]="IsLoading() == true"
			[(ngModel)]="GroupOption"
			(ngModelChange)="onGroupOptionChange($event)"
		/>
		<label for="Existing">Existing Group</label>

		<input
			style="margin-left: 10px"
			type="radio"
			id="New"
			value="New"
			name="GroupOption"
			[disabled]="IsLoading() == true"
			[(ngModel)]="GroupOption"
			(ngModelChange)="onGroupOptionChange($event)"
		/>
		<label for="New">New Group</label>
	</div>

	<label>School:</label>
	<select [disabled]="IsLoading() == true" class="form-control" name="School" [(ngModel)]="School" (ngModelChange)="onSchoolChange($event)">
		<option value="" style="display: none"></option>
		<option *ngFor="let o of lstSchool" [ngValue]="o">
			{{ o.SchoolFullName }}
		</option>
	</select>
	<!-- <caass-schoolselector
        [ShowAll]="false"
        [Disabled]="IsLoading() == true">
    </caass-schoolselector> -->
	<!-- <p-dropdown style="margin-left: 5px;" [disabled]="IsLoading() == true" [options]="lstSchool" [(ngModel)]="School" optionLabel="SchoolFullName" [filter]="true" filterBy="SchoolFullName" [showClear]="false" placeholder="Select a School" (ngModelChange)="onSchoolChange($event)">
        <ng-template pTemplate="selectedItem">
            <div *ngIf="School"> 
                <div class="form-control NoBorder" style="text-align: left;">{{School.SchoolFullName}}</div>
            </div>
        </ng-template>
        <ng-template let-SchoolItem pTemplate="item">
            <div>
                <div class="form-control NoBorder" style="text-align: left;">{{SchoolItem.SchoolFullName}}</div>
            </div>
        </ng-template>
    </p-dropdown> -->

	<label *ngIf="GroupOption == 'Existing'">Group:</label>
	<!-- <p-dropdown *ngIf="GroupOption == 'Existing'" style="margin-left: 5px;" [disabled]="IsLoading() == true" [options]="lstGroup" [(ngModel)]="SelectedGroup" optionLabel="GroupName" [filter]="true" filterBy="GroupName" [showClear]="false" placeholder="Select a Group">
        <ng-template pTemplate="selectedItem">
            <div *ngIf="SelectedGroup"> 
                <div class="form-control NoBorder" style="text-align: left;">{{SelectedGroup.GroupName}}</div>
            </div>
        </ng-template>
        <ng-template let-GroupItem pTemplate="item">
            <div>
                <div class="form-control NoBorder" style="text-align: left;">{{GroupItem.GroupName}}</div>
            </div>
        </ng-template>
    </p-dropdown> -->
	<select
		*ngIf="GroupOption == 'Existing'"
		style="margin-left: 5px"
		[disabled]="IsLoading() == true"
		class="form-control"
		name="School"
		[(ngModel)]="SelectedGroup"
	>
		<option value="" style="display: none"></option>
		<option *ngFor="let o of lstGroup" [ngValue]="o">
			{{ o.GroupName }}
		</option>
	</select>

	<label *ngIf="GroupOption == 'Existing'" for="AddGroupActions">Add Optional Group Actions:</label>
	<input *ngIf="GroupOption == 'Existing'" [disabled]="IsLoading() == true" class="CHK" type="checkbox" id="AddGroupActions" [(ngModel)]="AddGroupActions" />

	<label *ngIf="GroupOption == 'New'">Group Name:</label>
	<input *ngIf="GroupOption == 'New'" [disabled]="IsLoading() == true" type="text" class="form-control" [(ngModel)]="GroupName" />
</div>

<!--Students being added-->
<div>
	<caass-merge-to-group-student-table [lstPerson]="lstPerson" (SelectRow)="onSelectRow()"> </caass-merge-to-group-student-table>
</div>

<!--Buttons-->
<div class="Buttons">
	<button [disabled]="IsLoading() == true" class="btn btn-primary" (click)="onAddToGroup()">Merge to Group</button>
	<button [disabled]="Processing == true" class="btn btn-warning" (click)="onClose()">Close</button>
</div>

<!--Error Message-->
<div class="TopMargin">
	<div name="errorMessage" *ngIf="errorMessage" class="alert alert-danger">
		{{ errorMessage }}
	</div>
</div>
